import {Observable} from 'rxjs/Observable';
import {WfProcessPermissionsConfigsProvider} from "@synisys/ejustice-controls/src/app/controls/security/wf-process-permissions/service/wf-process-permissions-configs.provider";
import {ProcessPermissions} from "@synisys/ejustice-controls/src/app/controls/security/wf-process-permissions/model/process-permissions";

export class SSDWfProcessPermissionsConfigsProvider implements WfProcessPermissionsConfigsProvider {
	getConfigurations(): Observable<ProcessPermissions[]> {
		return Observable.of([
			{
				"category": "Project",
				"roles": [1, 2, 3],
				"firstClassifierField": "country",
				"firstClassifierLabel": "survey.cs_country",
				"secondClassifierField": "synergy_domain",
				"secondClassifierLabel": "synergy_domain",
			},
			{
				"category": "Ticket",
				"roles": [1, 2, 3],
				"firstClassifierField": "Project_Classifier",
				"firstClassifierLabel": "Project",
				"secondClassifierField": "Ticket_Type",
				"secondClassifierLabel": "Ticket Type",
			}
		] as ProcessPermissions[])
	}

}
